
export const companyLinks = [
    'About us', 'Careers', 'Privacy Policy', 'Cookie Policy'
]

export const resourcesLinks = [
    'Template Library', 'Blog', 'Help Center', 'Service Status', 'Experts', 'Forum'
]

export const solutionsLinks = [
    'Customer Portal', 'Internal Workflow App', 'Flexible CRM', 'Team Intranet', 'For Small-Medium Businesses', 'For Startups', 'For Enterprises'
]
// export { companyLinks, resourcesLinks, solutionsLinks }